import React from 'react';
import { Field } from 'redux-form';
import { AutocompleteArrayInput, TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CreateItem from '../../../Common/Partials/CreateItem';
import DeleteItem from '../../../Common/Partials/DeleteItem';
import PopoverHelp from '../../../Common/Popovers/Help';

const styles = createStyles({
  dropdown: {
    minWidth: 120
  },
  fields: {
    width: 130,
    marginTop: -15
  },
  popover: {
    marginLeft: 5
  }
});

type Props = {
  adSizes: string[],
  classes: any,
  fields: any
};

const SizeMappings = (props: Props) => (
  <div>
    <h5>
      Size Mappings
      <PopoverHelp
        className={props.classes.popover}
        content="This can be used to specify desired ad sizes at different screen widths.  Please list ad sizes from shortest to tallest in order to prevent jumping/shifting ads" />
    </h5>
    {props.fields.length > 0 && props.fields.map((item, index) => {
      return (
        <div key={index} style={{ flex: 1, border: '1px solid rgba(0, 0, 0, 0.298039)', padding: '5px 5px 5px 15px', display: 'inline-block', margin: 5, minWidth: 220 }}>
          <div style={{ paddingBottom: 10 }}>
            <div style={{ textAlign: 'center', paddingBottom: 20 }}>
              <div style={{ marginTop: 10 }}>
                <h5 style={{ display: 'inline', marginTop: 10 }}>Screen Size</h5>
                <div style={{ float: 'right', marginTop: -10 }}>
                  <DeleteItem fields={props.fields} index={index} />
                </div>
              </div>
            </div>
            <div>
              <Field
                className={props.classes.fields}
                component={TextInput}
                label="Minimum Width"
                name={`${item}.screen_size.width`}
                source={`${item}.screen_size.width`} />
            </div>
          </div>
          <div>
            <Field
              choices={props.adSizes}
              className={props.classes.dropdown}
              component={AutocompleteArrayInput}
              label="Ad Sizes"
              name={`${item}.ad_sizes`}
              source={`${item}.ad_sizes`} />
          </div>
        </div>
      )
    })}
    <div style={{ paddingTop: 10 }}>
      <CreateItem fields={props.fields} label="Add Size Mapping" />
    </div>
  </div>
);

export default withStyles(styles)(SizeMappings);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/SizeMappings.tsx